import React, { useEffect, useRef, useState } from 'react'
import { Form, Segment, Image, Modal, Input, Button, Grid, Confirm, Icon, Table, Header, List } from 'semantic-ui-react'
import { Formik } from 'formik'
import * as Yup from 'yup';
import rfidImage from '../Resources/images/rfid.png'
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { attStatusAction, saveAttendance, findAssetAction } from '../Redux/Actions/AttendanceAction'
import { logoutAction } from '../Redux/Actions/AuthAction'
import attention from '../Resources/images/attention.png';
import successCheck from '../Resources/images/success-green-check-mark.png';
import profileImage from '../Resources/images/profile.png';
import moment from 'moment';
import { IMAGE_URL } from '../Resources/Api'

const AttInterface = ({ history }) => {

    const dispatch = useDispatch()
    const authToken = localStorage.getItem('accessToken');
    const cardInputRef = useRef();
    const scanInputRef = useRef();
    const [attModalOpen, setAttModalOpen] = useState(false)
    const [message, setMessage] = useState({})
    const attendanceStatus = useSelector(state => state.attendanceReducer.attStatusPayload)
    const assetData = useSelector(state => state.attendanceReducer.findAssetPayload)
    // useEffect(() => {
    //     cardInputRef.current.focus();
    // })

    const [showConfirm, setShowConfirm] = useState(false);

    const [assetQr, setAssetQr] = useState('');
    const [assignAsset, setAssignAsset] = useState([]);

    const handleConfirm = () => {
        dispatch(logoutAction(authToken, history))
    }
    const handleAssetSubmit = () => {
        setAssetQr('');
        scanInputRef.current.focus();
        if (attendanceStatus && attendanceStatus.attStatus === 'IN') {
            dispatch(findAssetAction(assetQr, setAssetQr, assignAsset, setAssignAsset, setMessage, scanInputRef, authToken))
        } else {
            const assetsToMatch = assignAsset.slice();
            const findAsset = assignAsset.filter(item => item.assetQr === assetQr);
            const updateAssetWith = findAsset.map(item => {
                return {
                    assetListId: item.assetListId,
                    assetQr: item.assetQr,
                    assetName: item.assetName,
                    assignStatus: "R"
                }
            })
            let updateAsset = updateAssetWith[0];
            let clone = assetsToMatch;
            const index = clone.findIndex((obj) => obj.assetQr === updateAsset.assetQr);
            if (index !== -1) clone[index] = updateAsset;
            setAssignAsset(clone)
        }
    }

    const [cardNumber, setCardNumber] = useState('');

    const handleCardSubmit = () => {
        dispatch(attStatusAction(
            cardNumber,
            setCardNumber,
            setAssignAsset,
            setAttModalOpen,
            setMessage,
            cardInputRef,
            scanInputRef,
            authToken
        ))
    }

    const handleAttendanceSubmit = () => {
        const assignAssetToSubmit = assignAsset.filter(item => item.assetListId !== "")
        dispatch(saveAttendance(
            attendanceStatus.employee.id,
            attendanceStatus.post.id,
            attendanceStatus.shift.id,
            assignAssetToSubmit,
            setAttModalOpen,
            setMessage,
            cardInputRef,
            scanInputRef,
            authToken
        ))
    }

    // console.log(assignAsset);

    return (
        <Segment className="att-container" placeholder>
            <Button
                onClick={() => setShowConfirm(true)}
                circular
                icon="power off"
                color='google plus'
                style={{
                    position: 'absolute',
                    top: 10,
                    right: 10
                }} />
            <Confirm
                open={showConfirm}
                onCancel={() => setShowConfirm(false)}
                onConfirm={() => handleConfirm()}
                size='mini'
            />
            <Modal
                dimmer='blurring'
                size='mini'
                open={message && message.status}
                className="error-poper">
                <Modal.Content style={{ textAlign: 'center' }}>
                    <Image src={message.type === "error" ? attention : successCheck} />
                    <h2>!Opps...</h2>
                    <h4>{message && message.message}</h4>
                </Modal.Content>
            </Modal>
            <div className="att-content">
                <Image className="login-logo" src={rfidImage} />
                <h2 style={{ textAlign: 'center' }}>Touch your card to reader</h2>
                <div
                // style={{ opacity: 0, position: 'absolute' }}
                >
                    <Form>
                        <Input
                            type='text'
                            ref={cardInputRef}
                            placeholder='Search...'
                            action
                            autoFocus
                            value={cardNumber}
                            onChange={(e) => setCardNumber(e.target.value)}>
                            <input />
                            <Button onClick={handleCardSubmit} type='submit'>Search</Button>
                        </Input>
                    </Form>
                </div>
            </div>
            <Modal
                dimmer='blurring'
                size='small'
                open={attModalOpen}
                className="att-asset-assign-modal">
                <Modal.Header>Asset Assignment</Modal.Header>
                <Modal.Content>
                    <Grid columns='equal'>
                        <Grid.Column>
                            <Segment>
                                <Image
                                    src={attendanceStatus && attendanceStatus.employee.image ? `${IMAGE_URL + attendanceStatus.employee.image}` : profileImage}
                                    size='tiny'
                                    width={80}
                                    height={80}
                                    circular />
                                <Grid>
                                    <Grid.Column width={5}>
                                        <h4>Name:</h4>
                                    </Grid.Column>
                                    <Grid.Column width={11}>
                                        <h4>{attendanceStatus && attendanceStatus.employee.name}</h4>
                                    </Grid.Column>
                                </Grid>
                                <Grid>
                                    <Grid.Column width={5}>
                                        <h4>Post:</h4>
                                    </Grid.Column>
                                    <Grid.Column width={11}>
                                        <h4>{attendanceStatus && attendanceStatus.post.name}</h4>
                                    </Grid.Column>
                                </Grid>
                                <Grid>
                                    <Grid.Column width={5}>
                                        <h4>Shift:</h4>
                                    </Grid.Column>
                                    <Grid.Column width={11}>
                                        <h4>{attendanceStatus && attendanceStatus.shift.name}</h4>
                                    </Grid.Column>
                                </Grid>
                                <Grid>
                                    <Grid.Column width={5}>
                                        <h4>In Time:</h4>
                                    </Grid.Column>
                                    <Grid.Column width={11}>
                                        <h4>
                                            {attendanceStatus && attendanceStatus.attStatus === 'IN' ?
                                                moment().format('DD-MM-YYYY - HH:MM') :
                                                moment(attendanceStatus && attendanceStatus.attendance.created_at).format('DD-MM-YYYY - HH:MM')}
                                        </h4>
                                    </Grid.Column>
                                </Grid>
                                <Grid>
                                    <Grid.Column width={5}>
                                        <h4>Out Time:</h4>
                                    </Grid.Column>
                                    <Grid.Column width={11}>
                                        <h4>
                                            {attendanceStatus && attendanceStatus.attStatus === 'OUT' ?
                                                moment().format('DD-MM-YYYY - HH:MM') : ""}
                                        </h4>
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment>
                                <Grid centered columns={1}>
                                    <Grid.Column style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Form>
                                            <Fragment>
                                                <Input
                                                    type='text'
                                                    placeholder='Scan...'
                                                    ref={scanInputRef}
                                                    value={assetQr}
                                                    onChange={e => setAssetQr(e.target.value)}
                                                    action>
                                                    <input />
                                                    <Button
                                                        type="submit"
                                                        icon
                                                        positive
                                                        onClick={handleAssetSubmit}>
                                                        <Icon name='check' />
                                                    </Button>
                                                </Input>
                                            </Fragment>
                                        </Form>
                                    </Grid.Column>
                                </Grid>
                                <Grid centered columns={1}>
                                    <Grid.Column>
                                        <Table basic='very' celled collapsing style={{ margin: '0 auto' }}>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Asset Name</Table.HeaderCell>
                                                    <Table.HeaderCell>Asset Qr</Table.HeaderCell>
                                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>

                                            <Table.Body>
                                                {assignAsset !== [] && assignAsset.map((item, index) =>
                                                    <Table.Row key={index}>
                                                        <Table.Cell>
                                                            <Header as='h4' image>
                                                                <Header.Content>
                                                                    {item.assetName}
                                                                </Header.Content>
                                                            </Header>
                                                        </Table.Cell>
                                                        <Table.Cell>{item.assetQr}</Table.Cell>
                                                        <Table.Cell
                                                            style={item.assignStatus === "A" ? { color: 'red' } :
                                                                item.assignStatus === "R" ? { color: 'green' } :
                                                                    item.assignStatus === "N" ? { color: 'blue' } : ""}>
                                                            {item.assignStatus === "A" ? "Assigned" :
                                                                item.assignStatus === "R" ? "Returned" :
                                                                    item.assignStatus === "N" ? "Not Asigned" : ""}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                )}
                                            </Table.Body>
                                        </Table>
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                        </Grid.Column>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button positive onClick={handleAttendanceSubmit}>
                        Done
                    </Button>
                </Modal.Actions>
            </Modal>
        </Segment>
    )
}

export default AttInterface